module.exports = __webpack_public_path__ + "images/emails/statistics/sky-470a4ac487d044e594995d54f94196cf.png";